(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HEADER-ROY"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > 50) {
        // Scrolling DOWN -> Detach & Hide
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 50) {
        // Scrolling UP -> Detach & Reveal
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 10) {
        // At Top -> Reset / Merge back with Hero
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vankea-components-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vk-components]').forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-product-card]'));
    const rails = Array.from(root.querySelectorAll('[data-category-rail]'));
    const buttons = Array.from(root.querySelectorAll('[data-category]'));
    const search = root.querySelector('[data-product-search]');
    const sort = root.querySelector('[data-product-sort]');
    const visibleCount = root.querySelector('[data-visible-count]');
    const resultsLabel = root.querySelector('[data-results-label]');
    const empty = root.querySelector('[data-products-empty]');
    const clear = root.querySelector('[data-clear-products]');
    const params = new URLSearchParams(window.location.search);
    let category = params.get('component') || 'all';

    const validCategories = ['all', 'windows', 'seating', 'showers', 'power', 'climate', 'hardware'];
    if (!validCategories.includes(category)) category = 'all';

    const categoryCounts = cards.reduce((counts, card) => {
      counts.all += 1;
      counts[card.dataset.category] = (counts[card.dataset.category] || 0) + 1;
      return counts;
    }, { all: 0 });

    root.querySelectorAll('[data-category-count]').forEach((node) => {
      node.textContent = categoryCounts[node.dataset.categoryCount] || 0;
    });

    const syncButtons = () => {
      buttons.forEach((button) => {
        const active = button.dataset.category === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active.toString());
      });
    };

    const update = () => {
      const term = search.value.trim().toLowerCase();
      let shown = 0;

      cards.forEach((card) => {
        const categoryMatch = category === 'all' || card.dataset.category === category;
        const searchMatch = !term || card.dataset.search.includes(term);
        const show = categoryMatch && searchMatch;
        card.hidden = !show;
        if (show) shown += 1;
      });

      visibleCount.textContent = shown;
      resultsLabel.textContent = shown === 1 ? 'component' : 'components';
      empty.hidden = shown !== 0;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.category;
        syncButtons();
        if (category === 'all') params.delete('component');
        else params.set('component', category);
        const query = params.toString();
        window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
        update();
        if (button.closest('.vk-components__mobile-categories')) {
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    search.addEventListener('input', update);

    clear.addEventListener('click', () => {
      category = 'all';
      search.value = '';
      params.delete('component');
      window.history.replaceState({}, '', `${window.location.pathname}${window.location.hash}`);
      syncButtons();
      update();
      search.focus();
    });

    sort.addEventListener('change', () => {
      if (sort.value) params.set('sort_by', sort.value);
      else params.delete('sort_by');
      window.location.search = params.toString();
    });

    rails.forEach((rail) => {
      const active = rail.querySelector(`[data-category="${category}"]`);
      if (active) active.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
    });

    syncButtons();
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vankea-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vk-faq]').forEach((root) => {
    const input = root.querySelector('[data-faq-search]');
    const filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const count = root.querySelector('[data-faq-count]');
    const empty = root.querySelector('[data-faq-empty]');
    let category = 'all';

    const update = () => {
      const term = input.value.trim().toLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const categoryMatches = category === 'all' || item.dataset.category === category;
        const searchMatches = !term || item.dataset.search.includes(term);
        const show = categoryMatches && searchMatches;
        item.hidden = !show;
        if (show) visible += 1;
      });

      count.textContent = `${visible} ${visible === 1 ? 'answer' : 'answers'}`;
      empty.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.faqFilter;
        filters.forEach((filter) => {
          const active = filter === button;
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', active.toString());
        });
        update();
      });
    });

    input.addEventListener('input', update);

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    document.addEventListener('keydown', (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        input.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vankea-product-build-gallery"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function mountGallery(root){
      if(!root)return;
      var sourceWrapper=root.closest('.shopify-section');
      var productRoot=document.querySelector('.vpr[data-section-id]');
      var slot=productRoot&&productRoot.querySelector('[data-vpr-build-gallery-slot]');

      // Backward-compatible fallback: create a normal-flow mount directly after the hero.
      if(productRoot&&!slot){
        var hero=productRoot.querySelector('.vpr__hero');
        var contentStart=productRoot.querySelector('.vpr__content-tabs')||productRoot.querySelector('.vpr__facts')||productRoot.querySelector('.vpr__content-grid');
        if(hero&&hero.parentElement){
          slot=document.createElement('div');
          slot.className='vpr__build-gallery-slot';
          slot.setAttribute('data-vpr-build-gallery-slot','');
          if(contentStart&&contentStart.parentElement===hero.parentElement)hero.parentElement.insertBefore(slot,contentStart);
          else hero.insertAdjacentElement('afterend',slot);
        }
      }

      // Only move the inner gallery section. Never move Shopify's outer section wrapper.
      if(slot&&root.parentElement!==slot){
        var oldGallery=slot.querySelector('[data-vbg]');
        if(oldGallery&&oldGallery!==root)oldGallery.remove();
        if(sourceWrapper&&sourceWrapper.id)root.dataset.vbgSourceSection=sourceWrapper.id;
        slot.appendChild(root);
      }
    }

    function initGallery(root){
      if(!root)return;
      // Mounting is intentionally retried even after initialization. This prevents the gallery
      // disappearing when Shopify loads/reorders sections in the theme editor or on mobile.
      mountGallery(root);
      if(root.dataset.initialized==='true')return;
      root.dataset.initialized='true';

      var panels=Array.prototype.slice.call(root.querySelectorAll('[data-vbg-panel]'));
      var pills=Array.prototype.slice.call(root.querySelectorAll('[data-vbg-filter]'));
      var viewport=root.querySelector('[data-vbg-panel="images"] [data-vbg-viewport]')||root.querySelector('[data-vbg-viewport]');
      var mobile=window.matchMedia('(max-width: 749px)');
      var speed=Math.max(Number(root.dataset.speed||44),24);
      var hover=false,focus=false,dragging=false,videoPlaying=false,dragMoved=false,suppressClick=false;
      var manualPauseUntil=0,startX=0,startScroll=0,lastTime=performance.now(),touchStartX=0,frameId=0;

      function activePanel(){return root.querySelector('[data-vbg-panel].is-active')}
      function temporarilyPause(ms){manualPauseUntil=Date.now()+(ms||6500)}
      function isPaused(){return mobile.matches||hover||focus||dragging||videoPlaying||document.hidden||Date.now()<manualPauseUntil}
      function cardDistance(){
        var active=activePanel(),view=active&&active.querySelector('[data-vbg-viewport]');
        var card=view&&view.querySelector('.vbg__card');
        return card?card.getBoundingClientRect().width+8:(view?view.clientWidth*.84:0);
      }
      function moveTrack(direction){
        var active=activePanel(),view=active&&active.querySelector('[data-vbg-viewport]');
        if(!view)return;
        temporarilyPause(6500);
        view.scrollBy({left:direction*cardDistance(),behavior:'smooth'});
      }
      function startFrame(){
        if(!frameId&&!mobile.matches){
          lastTime=performance.now();
          frameId=window.requestAnimationFrame(frame);
        }
      }
      function frame(now){
        frameId=0;
        var panel=activePanel(),view=panel&&panel.querySelector('[data-vbg-viewport]');
        var delta=Math.min(now-lastTime,40);lastTime=now;
        if(view&&!isPaused()){
          view.scrollLeft+=speed*delta/1000;
          var midpoint=view.scrollWidth/2;
          if(midpoint>0&&view.scrollLeft>=midpoint)view.scrollLeft-=midpoint;
        }
        startFrame();
      }
      if(mobile.addEventListener)mobile.addEventListener('change',startFrame);
      else if(mobile.addListener)mobile.addListener(startFrame);

      root.addEventListener('pointerenter',function(event){if(event.pointerType==='mouse')hover=true});
      root.addEventListener('pointerleave',function(){hover=false});
      root.addEventListener('focusin',function(){focus=true});
      root.addEventListener('focusout',function(event){if(!root.contains(event.relatedTarget))focus=false});
      var trackPrevious=root.querySelector('[data-vbg-track-previous]');
      var trackNext=root.querySelector('[data-vbg-track-next]');
      if(trackPrevious)trackPrevious.addEventListener('click',function(){moveTrack(-1)});
      if(trackNext)trackNext.addEventListener('click',function(){moveTrack(1)});

      root.querySelectorAll('[data-vbg-viewport]').forEach(function(view){
        var nativeTouchStart=null,nativeTouchMoved=false;
        view.addEventListener('touchstart',function(event){
          if(event.touches.length!==1){nativeTouchStart=null;return}
          nativeTouchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
          nativeTouchMoved=false;
        },{passive:true});
        view.addEventListener('touchmove',function(event){
          if(!nativeTouchStart||!event.touches.length)return;
          var dx=event.touches[0].clientX-nativeTouchStart.x;
          var dy=event.touches[0].clientY-nativeTouchStart.y;
          if(Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy))nativeTouchMoved=true;
        },{passive:true});
        view.addEventListener('touchend',function(){
          nativeTouchStart=null;
          if(nativeTouchMoved){
            suppressClick=true;
            setTimeout(function(){suppressClick=false},260);
          }
        },{passive:true});
        view.addEventListener('touchcancel',function(){nativeTouchStart=null;nativeTouchMoved=false},{passive:true});
        view.addEventListener('pointerdown',function(event){
          if(event.pointerType!=='mouse')return;
          dragging=true;dragMoved=false;suppressClick=false;startX=event.clientX;startScroll=view.scrollLeft;
          temporarilyPause(7000);view.classList.add('is-dragging');
        });
        view.addEventListener('pointermove',function(event){
          if(event.pointerType!=='mouse'||!dragging)return;
          if(Math.abs(event.clientX-startX)>8){
            dragMoved=true;suppressClick=true;
            if(view.setPointerCapture&&(!view.hasPointerCapture||!view.hasPointerCapture(event.pointerId)))view.setPointerCapture(event.pointerId);
          }
          view.scrollLeft=startScroll-(event.clientX-startX);
        });
        function stopDrag(event){if(event.pointerType!=='mouse')return;dragging=false;view.classList.remove('is-dragging');if(suppressClick)setTimeout(function(){suppressClick=false},220)}
        view.addEventListener('pointerup',stopDrag);
        view.addEventListener('pointercancel',stopDrag);
        view.addEventListener('keydown',function(event){
          if(event.key==='ArrowRight'){event.preventDefault();moveTrack(1)}
          if(event.key==='ArrowLeft'){event.preventDefault();moveTrack(-1)}
        });
      });

      var imageData=[];
      root.querySelectorAll('[data-vbg-grid-image]').forEach(function(button){
        imageData.push({src:button.dataset.src,alt:button.dataset.alt});
      });
      if(!imageData.length){
        root.querySelectorAll('[data-vbg-image]').forEach(function(button){
          if(!imageData.some(function(item){return item.src===button.dataset.src}))imageData.push({src:button.dataset.src,alt:button.dataset.alt});
        });
      }
      var imageDialog=root.querySelector('[data-vbg-lightbox]');
      var lightboxImage=imageDialog&&imageDialog.querySelector('[data-vbg-lightbox-image]');
      var imageCounter=imageDialog&&imageDialog.querySelector('[data-vbg-counter]');
      var lightboxThumbs=imageDialog?Array.prototype.slice.call(imageDialog.querySelectorAll('[data-vbg-lightbox-thumb]')):[];
      var currentImage=0;
      function showImage(index){
        if(!imageDialog||!imageData.length)return;
        currentImage=(index+imageData.length)%imageData.length;
        lightboxImage.src=imageData[currentImage].src;
        lightboxImage.alt=imageData[currentImage].alt;
        imageCounter.textContent=(currentImage+1)+' / '+imageData.length;
        lightboxThumbs.forEach(function(thumb,i){
          var active=i===currentImage;
          thumb.classList.toggle('is-active',active);
          thumb.setAttribute('aria-current',active?'true':'false');
          if(active&&thumb.scrollIntoView)thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
        });
      }
      function openImage(index){
        showImage(index);
        if(imageDialog&&!imageDialog.open)imageDialog.showModal();
      }
      root.querySelectorAll('[data-vbg-image]').forEach(function(button){
        function activateImage(){
          if(suppressClick)return;
          var index=imageData.findIndex(function(item){return item.src===button.dataset.src});
          openImage(Math.max(index,0));
        }
        button.addEventListener('click',function(event){
          if(suppressClick){event.preventDefault();return}
          temporarilyPause(6500);
          activateImage();
        });
      });
      if(imageDialog){
        lightboxThumbs.forEach(function(thumb){thumb.addEventListener('click',function(){showImage(Number(thumb.dataset.vbgLightboxThumb)||0)})});
        imageDialog.querySelector('[data-vbg-previous]').addEventListener('click',function(){showImage(currentImage-1)});
        imageDialog.querySelector('[data-vbg-next]').addEventListener('click',function(){showImage(currentImage+1)});
        imageDialog.querySelector('[data-vbg-close]').addEventListener('click',function(){imageDialog.close()});
        imageDialog.addEventListener('click',function(event){if(event.target===imageDialog)imageDialog.close()});
        imageDialog.addEventListener('keydown',function(event){if(event.key==='ArrowLeft')showImage(currentImage-1);if(event.key==='ArrowRight')showImage(currentImage+1)});
        imageDialog.addEventListener('touchstart',function(event){touchStartX=event.changedTouches[0].clientX},{passive:true});
        imageDialog.addEventListener('touchend',function(event){var distance=event.changedTouches[0].clientX-touchStartX;if(Math.abs(distance)>45)showImage(currentImage+(distance<0?1:-1))},{passive:true});
      }

      var videoDialog=root.querySelector('[data-vbg-video-dialog]');
      var videoSlides=videoDialog?Array.prototype.slice.call(videoDialog.querySelectorAll('[data-vbg-video-slide]')):[];
      var videoCounter=videoDialog&&videoDialog.querySelector('[data-vbg-video-counter]');
      var currentVideo=0,videoTouchStart=0;
      function pauseVideos(){videoSlides.forEach(function(slide){var video=slide.querySelector('video');if(video)video.pause()})}
      function showVideo(index){
        if(!videoSlides.length)return;
        pauseVideos();currentVideo=(index+videoSlides.length)%videoSlides.length;
        videoSlides.forEach(function(slide,i){slide.classList.toggle('is-active',i===currentVideo)});
        if(videoCounter)videoCounter.textContent=(currentVideo+1)+' / '+videoSlides.length;
      }
      function openVideos(index){
        if(!videoDialog)return;
        showVideo(Number(index)||0);videoPlaying=true;
        if(!videoDialog.open)videoDialog.showModal();
      }
      function closeVideos(){if(!videoDialog)return;pauseVideos();videoPlaying=false;videoDialog.close()}
      if(videoDialog){
        videoDialog.querySelector('[data-vbg-close-videos]').addEventListener('click',closeVideos);
        videoDialog.querySelector('[data-vbg-video-previous]').addEventListener('click',function(){showVideo(currentVideo-1)});
        videoDialog.querySelector('[data-vbg-video-next]').addEventListener('click',function(){showVideo(currentVideo+1)});
        videoDialog.addEventListener('click',function(event){if(event.target===videoDialog)closeVideos()});
        videoDialog.addEventListener('keydown',function(event){if(event.key==='ArrowLeft')showVideo(currentVideo-1);if(event.key==='ArrowRight')showVideo(currentVideo+1)});
        videoDialog.addEventListener('touchstart',function(event){videoTouchStart=event.changedTouches[0].clientX},{passive:true});
        videoDialog.addEventListener('touchend',function(event){var distance=event.changedTouches[0].clientX-videoTouchStart;if(Math.abs(distance)>45)showVideo(currentVideo+(distance<0?1:-1))},{passive:true});
        videoDialog.addEventListener('close',function(){pauseVideos();videoPlaying=false});
      }

      pills.forEach(function(pill){
        pill.addEventListener('click',function(){
          if(pill.dataset.vbgFilter==='videos'){openVideos(0);return}
          panels.forEach(function(panel){var active=panel.dataset.vbgPanel==='images';panel.classList.toggle('is-active',active);panel.hidden=!active});
          pills.forEach(function(item){var active=item===pill;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false')});
        });
      });

      var allDialog=root.querySelector('[data-vbg-all-dialog]');
      var openAll=root.querySelector('[data-vbg-open-all]');
      if(openAll&&allDialog)openAll.addEventListener('click',function(){allDialog.showModal()});
      if(allDialog){
        allDialog.querySelector('[data-vbg-close-all]').addEventListener('click',function(){allDialog.close()});
        allDialog.addEventListener('click',function(event){if(event.target===allDialog)allDialog.close()});
        allDialog.querySelectorAll('[data-vbg-grid-image]').forEach(function(button){
          button.addEventListener('click',function(){allDialog.close();openImage(Number(button.dataset.vbgGridImage)||0)});
        });
        allDialog.querySelectorAll('[data-vbg-grid-video]').forEach(function(button){
          button.addEventListener('click',function(){allDialog.close();openVideos(Number(button.dataset.vbgGridVideo)||0)});
        });
      }
      startFrame();
    }
    function initAll(scope){
      if(scope.matches&&scope.matches('[data-vbg]'))initGallery(scope);
      if(scope.querySelectorAll)scope.querySelectorAll('[data-vbg]').forEach(initGallery);
    }
    function refreshAll(){initAll(document)}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshAll);else refreshAll();
    window.addEventListener('load',refreshAll,{once:true});
    document.addEventListener('shopify:section:load',function(){refreshAll()});
    document.addEventListener('shopify:section:reorder',function(){refreshAll()});
    document.addEventListener('shopify:block:select',function(){refreshAll()});
    setTimeout(refreshAll,120);
    setTimeout(refreshAll,650);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vankea-product-redesign-refresh"] && !Shopify.designMode) return;
  try {
    

(function(){
  function initCopyPages(scope){
    scope.querySelectorAll('.vpr--cabinet-one .vpr__content-main .vpr__detail-body').forEach(function(body,index){
      if(body.dataset.copyPaged)return;
      var card=body.closest('.vpr__detail');
      if(!card||card.classList.contains('vpr__card--installation')||card.classList.contains('vpr__card--compatibility')||body.classList.contains('vpr__spec-table'))return;
      if(body.querySelectorAll('p').length<2&&!card.classList.contains('vpr__card--materials'))return;
      var blocks=[];
      function collect(parent){
        Array.from(parent.childNodes).forEach(function(node){
          if(node.nodeType===3){if(node.textContent.trim()){var p=document.createElement('p');p.textContent=node.textContent;blocks.push(p)}return}
          if(node.nodeType!==1)return;
          if(node.classList.contains('vpr__richtext')){collect(node);return}
          if(node.tagName==='UL'&&node.classList.contains('vpr__check-list')){
            var rows=Array.from(node.children);
            for(var n=0;n<rows.length;n+=3){var list=node.cloneNode(false);rows.slice(n,n+3).forEach(function(row){list.appendChild(row.cloneNode(true))});blocks.push(list)}
          }else blocks.push(node.cloneNode(true));
        });
      }
      collect(body);
      var pages=[],pending=[];
      blocks.forEach(function(block){
        if(/^H[1-6]$/.test(block.tagName)){pending.push(block);return}
        var page=document.createElement('div');page.className='vk-copy-page';
        pending.forEach(function(h){page.appendChild(h)});pending=[];page.appendChild(block);pages.push(page);
      });
      if(pending.length&&pages.length)pending.forEach(function(h){pages[pages.length-1].appendChild(h)});
      if(pages.length<2)return;
      body.dataset.copyPaged='true';
      var viewport=document.createElement('div');viewport.className='vk-copy-viewport';viewport.tabIndex=0;viewport.setAttribute('aria-label','Description pages');
      var id=(body.closest('[data-section-id]').id||'cabinet')+'-copy-'+index;
      viewport.id=id;
      pages.forEach(function(page,n){page.hidden=n!==0;page.setAttribute('role','group');page.setAttribute('aria-label','Page '+(n+1)+' of '+pages.length);viewport.appendChild(page)});
      var nav=document.createElement('div');nav.className='vk-copy-nav';nav.setAttribute('aria-label','Description pagination');
      var prev=document.createElement('button');prev.type='button';prev.className='vk-copy-arrow';prev.textContent='←';prev.setAttribute('aria-label','Previous description page');
      var next=document.createElement('button');next.type='button';next.className='vk-copy-arrow';next.textContent='→';next.setAttribute('aria-label','Next description page');
      var dots=document.createElement('div');dots.className='vk-copy-dots';
      var status=document.createElement('span');status.className='vk-copy-status';status.setAttribute('aria-live','polite');
      var active=0,buttons=[];
      function show(n){active=Math.max(0,Math.min(pages.length-1,n));pages.forEach(function(p,i){p.hidden=i!==active});buttons.forEach(function(b,i){b.setAttribute('aria-current',i===active?'true':'false')});prev.disabled=active===0;next.disabled=active===pages.length-1;status.textContent=(active+1)+' / '+pages.length}
      pages.forEach(function(page,n){var b=document.createElement('button');b.type='button';b.className='vk-copy-dot';b.setAttribute('aria-label','Show description page '+(n+1));b.setAttribute('aria-controls',id);b.addEventListener('click',function(){show(n)});dots.appendChild(b);buttons.push(b)});
      prev.addEventListener('click',function(){show(active-1)});next.addEventListener('click',function(){show(active+1)});
      viewport.addEventListener('keydown',function(e){if(e.target!==viewport)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1))}});
      var start=null;
      viewport.addEventListener('touchstart',function(e){if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY};else start=null},{passive:true});
      viewport.addEventListener('touchend',function(e){if(!start||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)show(active+(dx<0?1:-1))},{passive:true});
      viewport.addEventListener('touchcancel',function(){start=null},{passive:true});
      nav.append(prev,dots,next);body.replaceChildren(viewport,nav,status);show(0);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initCopyPages(document)});else initCopyPages(document);
  document.addEventListener('shopify:section:load',function(e){initCopyPages(e.target)});
})();

function initFeatureSliders(scope){scope.querySelectorAll('[data-feature-slider]').forEach(function(slider){if(slider.dataset.ready)return;slider.dataset.ready='true';var track=slider.querySelector('.vk-features__track'),prev=slider.querySelector('[data-feature-prev]'),next=slider.querySelector('[data-feature-next]'),count=slider.querySelector('[data-feature-count]');function step(){return track.firstElementChild.getBoundingClientRect().width+16}function update(){var max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=max-2;count.textContent=(Math.round(track.scrollLeft/step())+1)+' / '+track.children.length}function move(d){track.scrollBy({left:d*step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}prev.addEventListener('click',function(){move(-1)});next.addEventListener('click',function(){move(1)});track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});if(window.ResizeObserver)new ResizeObserver(update).observe(track);update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initFeatureSliders(document)});else initFeatureSliders(document);document.addEventListener('shopify:section:load',function(e){initFeatureSliders(e.target)});
  (function(){
    function initSection(root){
      if(!root||root.dataset.ready==='true')return;
      root.dataset.ready='true';
      var firstProductDropdown=root.querySelector('.vpr__card--details .product-dropdowns details');
      if(firstProductDropdown)firstProductDropdown.open=true;
      document.documentElement.classList.add('vpr-product-page');
      var revealItems=Array.prototype.slice.call(root.querySelectorAll('.vpr__facts,.vpr__detail,.vpr__dimension-card,.vpr__faq-card'));
      revealItems.forEach(function(item,itemIndex){
        item.classList.add('vpr__reveal-item');
        item.style.setProperty('--vpr-reveal-delay',String((itemIndex%3)*25)+'ms');
      });
      if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
        root.classList.add('vpr-reveal-ready');
        var revealObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },{threshold:.04,rootMargin:'0px 0px 5% 0px'});
        revealItems.forEach(function(item){revealObserver.observe(item)});
      }else{
        revealItems.forEach(function(item){item.classList.add('is-visible')});
      }
      Array.prototype.slice.call(root.querySelectorAll('.vpr__facts,.vpr__trust-strip')).forEach(function(scroller){
        var indicator=document.createElement('div');
        indicator.className='vpr__swipe-indicator';
        indicator.setAttribute('aria-hidden','true');
        indicator.innerHTML='<span class="vpr__swipe-indicator-arrow">‹</span><span class="vpr__swipe-track"><span class="vpr__swipe-thumb"></span></span><span class="vpr__swipe-indicator-arrow">›</span>';
        scroller.insertAdjacentElement('afterend',indicator);
        function updateSwipeIndicator(){
          var maxScroll=Math.max(0,scroller.scrollWidth-scroller.clientWidth);
          var progress=maxScroll>0?Math.min(1,Math.max(0,scroller.scrollLeft/maxScroll)):0;
          indicator.classList.toggle('is-active',maxScroll>2);
          indicator.classList.toggle('is-start',progress<.02);
          indicator.classList.toggle('is-end',progress>.98);
          indicator.style.setProperty('--vpr-swipe-offset',String(progress*38)+'px');
        }
        scroller.addEventListener('scroll',updateSwipeIndicator,{passive:true});
        if('ResizeObserver' in window){
          new ResizeObserver(updateSwipeIndicator).observe(scroller);
        }else{
          window.addEventListener('resize',updateSwipeIndicator,{passive:true});
        }
        requestAnimationFrame(updateSwipeIndicator);
      });
      var mainImage=root.querySelector('.vpr__main-image');
      var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var prev=root.querySelector('[data-gallery-prev]');
      var next=root.querySelector('[data-gallery-next]');
      var thumbScroller=root.querySelector('.vpr__thumbs');
      var thumbsUp=root.querySelector('[data-thumbs-up]');
      var thumbsDown=root.querySelector('[data-thumbs-down]');
      var counter=root.querySelector('[data-current-media]');
      var index=Math.max(0,thumbs.findIndex(function(item){return item.classList.contains('is-active')}));
      function showImage(nextIndex){
        if(!thumbs.length||!mainImage)return;
        index=(nextIndex+thumbs.length)%thumbs.length;
        var thumb=thumbs[index];
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src=thumb.dataset.src;
        mainImage.alt=thumb.dataset.alt||'';
        mainImage.setAttribute('data-media-id',thumb.dataset.mediaId||'');
        thumbs.forEach(function(item,itemIndex){
          var active=itemIndex===index;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-current',active?'true':'false');
        });
        if(counter)counter.textContent=String(index+1);
        thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      }
      thumbs.forEach(function(thumb,thumbIndex){thumb.addEventListener('click',function(){showImage(thumbIndex)})});
      if(prev)prev.addEventListener('click',function(){showImage(index-1)});
      if(next)next.addEventListener('click',function(){showImage(index+1)});
      function updateThumbNavigation(){
        if(!thumbScroller)return;
        if(thumbsUp)thumbsUp.disabled=thumbScroller.scrollTop<=1;
        if(thumbsDown)thumbsDown.disabled=thumbScroller.scrollTop+thumbScroller.clientHeight>=thumbScroller.scrollHeight-1;
      }
      function scrollThumbs(direction){
        if(!thumbScroller)return;
        thumbScroller.scrollBy({top:direction*Math.max(120,thumbScroller.clientHeight*.72),behavior:'smooth'});
      }
      if(thumbsUp)thumbsUp.addEventListener('click',function(){scrollThumbs(-1)});
      if(thumbsDown)thumbsDown.addEventListener('click',function(){scrollThumbs(1)});
      if(thumbScroller)thumbScroller.addEventListener('scroll',updateThumbNavigation,{passive:true});
      window.addEventListener('resize',updateThumbNavigation,{passive:true});
      updateThumbNavigation();

      var dimensionOpen=root.querySelector('[data-dimension-open]');
      var dimensionModal=root.querySelector('[data-dimension-modal]');
      var dimensionClose=root.querySelector('[data-dimension-close]');
      if(dimensionOpen&&dimensionModal){
        dimensionOpen.addEventListener('click',function(){dimensionModal.showModal()});
        if(dimensionClose)dimensionClose.addEventListener('click',function(){dimensionModal.close()});
        dimensionModal.addEventListener('click',function(event){if(event.target===dimensionModal)dimensionModal.close()});
        dimensionModal.addEventListener('close',function(){dimensionOpen.focus()});
      }

      var variantsNode=root.querySelector('[data-variants-json]');
      var variants=variantsNode?JSON.parse(variantsNode.textContent):[];
      var optionGroups=Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
      var variantInput=root.querySelector('[data-variant-id]');
      var price=root.querySelector('[data-price]');
      var compare=root.querySelector('[data-compare-price]');
      var status=root.querySelector('[data-status]');
      var addButton=root.querySelector('[data-add-button]');
      var addLabel=root.querySelector('[data-add-label]');
      var currencySymbol=root.dataset.currencySymbol||'$';
      function money(cents){return currencySymbol+(Number(cents||0)/100).toFixed(2)}
      function selectedOptions(){return optionGroups.map(function(group){var active=group.querySelector('[data-option-value].is-active');return active?active.dataset.optionValue:''})}
      function updateVariant(){
        var selected=selectedOptions();
        var variant=variants.find(function(item){return selected.every(function(value,itemIndex){return String(item.options[itemIndex])===String(value)})});
        optionGroups.forEach(function(group){var selectedLabel=group.querySelector('[data-selected-option]');var active=group.querySelector('[data-option-value].is-active');if(selectedLabel&&active)selectedLabel.textContent=active.dataset.optionValue});
        if(!variant)return;
        if(variantInput)variantInput.value=variant.id;
        if(price)price.textContent=money(variant.price);
        if(compare){if(variant.compare_at_price&&Number(variant.compare_at_price)>Number(variant.price)){compare.textContent=money(variant.compare_at_price);compare.classList.remove('is-hidden')}else{compare.textContent='';compare.classList.add('is-hidden')}}
        if(status)status.innerHTML=variant.available?'<span class="vpr__status-dot"></span>'+root.dataset.inStockText:root.dataset.soldOutText;
        if(addButton)addButton.disabled=!variant.available;
        if(addLabel)addLabel.textContent=variant.available?root.dataset.addText:root.dataset.soldOutText;
        if(variant.featured_media&&variant.featured_media.id){var mediaThumb=thumbs.find(function(item){return String(item.dataset.mediaId)===String(variant.featured_media.id)});if(mediaThumb)showImage(thumbs.indexOf(mediaThumb))}
        if(window.history&&window.history.replaceState){var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url.toString())}
      }
      optionGroups.forEach(function(group){group.querySelectorAll('[data-option-value]').forEach(function(button){button.addEventListener('click',function(){group.querySelectorAll('[data-option-value]').forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false')});button.classList.add('is-active');button.setAttribute('aria-pressed','true');updateVariant()})})});
      var quantity=root.querySelector('[data-qty-input]');
      var minus=root.querySelector('[data-qty-minus]');
      var plus=root.querySelector('[data-qty-plus]');
      if(minus&&quantity)minus.addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)-1)});
      if(plus&&quantity)plus.addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)+1)});
    }
    function initAll(){document.querySelectorAll('.vpr[data-section-id]').forEach(initSection)}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll)}else{initAll()}
    document.addEventListener('shopify:section:load',function(event){var root=event.target.querySelector('.vpr[data-section-id]');if(root)initSection(root)});
  })();

(function(){
function initPremiumAuto(scope){
scope.querySelectorAll('.vpr--cabinet-one [data-feature-slider],.vpr--cabinet-one .vpr__card--materials').forEach(function(root){
if(root.dataset.premiumAuto)return;
var feature=root.hasAttribute('data-feature-slider'),track=root.querySelector('.vk-features__track'),pages=feature?Array.from(track.children):Array.from(root.querySelectorAll('.vk-copy-page'));
if(pages.length<2)return;
root.dataset.premiumAuto='true';
var controls=document.createElement('div');controls.className='vk-auto-controls';
var toggle=document.createElement('button');toggle.type='button';toggle.className='vk-auto-toggle';
var reduced=window.matchMedia('(prefers-reduced-motion: reduce)'),paused=reduced.matches,hover=false,visible=false,last=Date.now(),interval=feature?6500:9000;
function setToggle(){toggle.textContent=paused?'Play slideshow':'Pause slideshow';toggle.setAttribute('aria-label',(paused?'Play ':'Pause ')+(feature?'main features':'materials')+' slideshow')}
function index(){return feature?Math.round(track.scrollLeft/(track.firstElementChild.getBoundingClientRect().width+16)):Math.max(0,pages.findIndex(function(p){return !p.hidden}))}
function go(n){if(feature)track.scrollTo({left:n*(track.firstElementChild.getBoundingClientRect().width+16),behavior:reduced.matches?'auto':'smooth'});else root.querySelectorAll('.vk-copy-dot')[n].click();last=Date.now()}
if(feature){var dots=document.createElement('div');dots.className='vk-auto-dots';pages.forEach(function(p,n){var b=document.createElement('button');b.type='button';b.className='vk-auto-dot';b.setAttribute('aria-label','Show feature '+(n+1));b.addEventListener('click',function(){go(n)});dots.appendChild(b)});controls.appendChild(dots);function sync(){Array.from(dots.children).forEach(function(b,n){b.setAttribute('aria-current',n===index()?'true':'false')})}track.addEventListener('scroll',sync,{passive:true});sync()}
toggle.addEventListener('click',function(){paused=!paused;last=Date.now();setToggle()});setToggle();controls.appendChild(toggle);
if(feature)root.appendChild(controls);else root.querySelector('.vpr__detail-body').appendChild(controls);
root.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')hover=true});
root.addEventListener('pointerleave',function(){hover=false;last=Date.now()});
root.addEventListener('pointerdown',function(){last=Date.now()},{passive:true});
root.addEventListener('keydown',function(){last=Date.now()});
root.addEventListener('click',function(e){if(e.isTrusted)last=Date.now()});
root.addEventListener('focusout',function(){last=Date.now()});
var observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;last=Date.now()},{threshold:.35});observer.observe(root);
var timer=setInterval(function(){if(!root.isConnected){clearInterval(timer);observer.disconnect();return}if(paused||hover||!visible||document.hidden||root.contains(document.activeElement)||(!feature&&!root.open)){last=Date.now();return}if(Date.now()-last>=interval)go((index()+1)%pages.length)},500);
reduced.addEventListener('change',function(){if(reduced.matches){paused=true;setToggle()}last=Date.now()});
});
}
function run(){initPremiumAuto(document)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
document.addEventListener('shopify:section:load',function(e){initPremiumAuto(e.target)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vankea-product-redesign"] && !Shopify.designMode) return;
  try {
    

(function(){
  function initCopyPages(scope){
    scope.querySelectorAll('.vpr--cabinet-one .vpr__content-main .vpr__detail-body').forEach(function(body,index){
      if(body.dataset.copyPaged)return;
      var card=body.closest('.vpr__detail');
      if(!card||card.classList.contains('vpr__card--installation')||card.classList.contains('vpr__card--compatibility')||body.classList.contains('vpr__spec-table'))return;
      // Side-by-side cards need to use their available height efficiently. Keep their
      // full content unpacked instead of turning it into a one-page-at-a-time slider,
      // which can leave a large empty area when the neighboring card is taller.
      if(card.closest('.vpr__two-up')){
        body.dataset.copyPaged='unpacked';
        return;
      }
      if(body.querySelectorAll('p').length<2&&!card.classList.contains('vpr__card--materials'))return;
      var blocks=[];
      function collect(parent){
        Array.from(parent.childNodes).forEach(function(node){
          if(node.nodeType===3){if(node.textContent.trim()){var p=document.createElement('p');p.textContent=node.textContent;blocks.push(p)}return}
          if(node.nodeType!==1)return;
          if(node.classList.contains('vpr__richtext')){collect(node);return}
          if(node.tagName==='UL'&&node.classList.contains('vpr__check-list')){
            var rows=Array.from(node.children);
            for(var n=0;n<rows.length;n+=3){var list=node.cloneNode(false);rows.slice(n,n+3).forEach(function(row){list.appendChild(row.cloneNode(true))});blocks.push(list)}
          }else blocks.push(node.cloneNode(true));
        });
      }
      collect(body);
      var pages=[],pending=[];
      blocks.forEach(function(block){
        if(/^H[1-6]$/.test(block.tagName)){pending.push(block);return}
        var page=document.createElement('div');page.className='vk-copy-page';
        pending.forEach(function(h){page.appendChild(h)});pending=[];page.appendChild(block);pages.push(page);
      });
      if(pending.length&&pages.length)pending.forEach(function(h){pages[pages.length-1].appendChild(h)});
      if(pages.length<2)return;
      body.dataset.copyPaged='true';
      var viewport=document.createElement('div');viewport.className='vk-copy-viewport';viewport.tabIndex=0;viewport.setAttribute('aria-label','Description pages');
      var id=(body.closest('[data-section-id]').id||'cabinet')+'-copy-'+index;
      viewport.id=id;
      pages.forEach(function(page,n){page.hidden=n!==0;page.setAttribute('role','group');page.setAttribute('aria-label','Page '+(n+1)+' of '+pages.length);viewport.appendChild(page)});
      var nav=document.createElement('div');nav.className='vk-copy-nav';nav.setAttribute('aria-label','Description pagination');
      var prev=document.createElement('button');prev.type='button';prev.className='vk-copy-arrow';prev.textContent='←';prev.setAttribute('aria-label','Previous description page');
      var next=document.createElement('button');next.type='button';next.className='vk-copy-arrow';next.textContent='→';next.setAttribute('aria-label','Next description page');
      var dots=document.createElement('div');dots.className='vk-copy-dots';
      var status=document.createElement('span');status.className='vk-copy-status';status.setAttribute('aria-live','polite');
      var active=0,buttons=[];
      function show(n){active=Math.max(0,Math.min(pages.length-1,n));pages.forEach(function(p,i){p.hidden=i!==active});buttons.forEach(function(b,i){b.setAttribute('aria-current',i===active?'true':'false')});prev.disabled=active===0;next.disabled=active===pages.length-1;status.textContent=(active+1)+' / '+pages.length}
      pages.forEach(function(page,n){var b=document.createElement('button');b.type='button';b.className='vk-copy-dot';b.setAttribute('aria-label','Show description page '+(n+1));b.setAttribute('aria-controls',id);b.addEventListener('click',function(){show(n)});dots.appendChild(b);buttons.push(b)});
      prev.addEventListener('click',function(){show(active-1)});next.addEventListener('click',function(){show(active+1)});
      viewport.addEventListener('keydown',function(e){if(e.target!==viewport)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1))}});
      var start=null;
      viewport.addEventListener('touchstart',function(e){if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY};else start=null},{passive:true});
      viewport.addEventListener('touchend',function(e){if(!start||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)show(active+(dx<0?1:-1))},{passive:true});
      viewport.addEventListener('touchcancel',function(){start=null},{passive:true});
      nav.append(prev,dots,next);body.replaceChildren(viewport,nav,status);show(0);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initCopyPages(document)});else initCopyPages(document);
  document.addEventListener('shopify:section:load',function(e){initCopyPages(e.target)});
})();

function initFeatureSliders(scope){scope.querySelectorAll('[data-feature-slider]').forEach(function(slider){if(slider.dataset.ready)return;slider.dataset.ready='true';var track=slider.querySelector('.vk-features__track'),prev=slider.querySelector('[data-feature-prev]'),next=slider.querySelector('[data-feature-next]'),count=slider.querySelector('[data-feature-count]');function step(){return track.firstElementChild.getBoundingClientRect().width+16}function update(){var max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=max-2;count.textContent=(Math.round(track.scrollLeft/step())+1)+' / '+track.children.length}function move(d){track.scrollBy({left:d*step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}prev.addEventListener('click',function(){move(-1)});next.addEventListener('click',function(){move(1)});track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});if(window.ResizeObserver)new ResizeObserver(update).observe(track);update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initFeatureSliders(document)});else initFeatureSliders(document);document.addEventListener('shopify:section:load',function(e){initFeatureSliders(e.target)});
  (function(){
    function initSection(root){
      if(!root||root.dataset.ready==='true')return;
      root.dataset.ready='true';
      var firstProductDropdown=root.querySelector('.vpr__card--details .product-dropdowns details');
      if(firstProductDropdown)firstProductDropdown.open=true;
      document.documentElement.classList.add('vpr-product-page');
      var revealItems=Array.prototype.slice.call(root.querySelectorAll('.vpr__facts,.vpr__detail,.vpr__dimension-card,.vpr__faq-card'));
      revealItems.forEach(function(item,itemIndex){
        item.classList.add('vpr__reveal-item');
        item.style.setProperty('--vpr-reveal-delay',String((itemIndex%3)*25)+'ms');
      });
      if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
        root.classList.add('vpr-reveal-ready');
        var revealObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },{threshold:.04,rootMargin:'0px 0px 5% 0px'});
        revealItems.forEach(function(item){revealObserver.observe(item)});
      }else{
        revealItems.forEach(function(item){item.classList.add('is-visible')});
      }
      Array.prototype.slice.call(root.querySelectorAll('.vpr__facts,.vpr__trust-strip')).forEach(function(scroller){
        var indicator=document.createElement('div');
        indicator.className='vpr__swipe-indicator';
        indicator.setAttribute('aria-hidden','true');
        indicator.innerHTML='<span class="vpr__swipe-indicator-arrow">‹</span><span class="vpr__swipe-track"><span class="vpr__swipe-thumb"></span></span><span class="vpr__swipe-indicator-arrow">›</span>';
        scroller.insertAdjacentElement('afterend',indicator);
        function updateSwipeIndicator(){
          var maxScroll=Math.max(0,scroller.scrollWidth-scroller.clientWidth);
          var progress=maxScroll>0?Math.min(1,Math.max(0,scroller.scrollLeft/maxScroll)):0;
          indicator.classList.toggle('is-active',maxScroll>2);
          indicator.classList.toggle('is-start',progress<.02);
          indicator.classList.toggle('is-end',progress>.98);
          indicator.style.setProperty('--vpr-swipe-offset',String(progress*38)+'px');
        }
        scroller.addEventListener('scroll',updateSwipeIndicator,{passive:true});
        if('ResizeObserver' in window){
          new ResizeObserver(updateSwipeIndicator).observe(scroller);
        }else{
          window.addEventListener('resize',updateSwipeIndicator,{passive:true});
        }
        requestAnimationFrame(updateSwipeIndicator);
      });
      var mainImage=root.querySelector('.vpr__main-image');
      var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var prev=root.querySelector('[data-gallery-prev]');
      var next=root.querySelector('[data-gallery-next]');
      var thumbScroller=root.querySelector('.vpr__thumbs');
      var thumbsUp=root.querySelector('[data-thumbs-up]');
      var thumbsDown=root.querySelector('[data-thumbs-down]');
      var counter=root.querySelector('[data-current-media]');
      var index=Math.max(0,thumbs.findIndex(function(item){return item.classList.contains('is-active')}));
      var mobileGallery=window.matchMedia('(max-width: 820px)');
      var imageCache=Object.create(null);
      var imageRequest=0;
      function imageSource(thumb){
        return mobileGallery.matches&&thumb.dataset.srcMobile?thumb.dataset.srcMobile:thumb.dataset.src;
      }
      function preloadImageAt(nextIndex){
        if(!thumbs.length)return;
        var preloadIndex=(nextIndex+thumbs.length)%thumbs.length;
        var src=imageSource(thumbs[preloadIndex]);
        if(!src||imageCache[src])return;
        var preload=new Image();
        preload.decoding='async';
        preload.src=src;
        imageCache[src]=preload;
      }
      function preloadAround(centerIndex){
        preloadImageAt(centerIndex+1);
        preloadImageAt(centerIndex-1);
        preloadImageAt(centerIndex+2);
      }
      function commitImage(thumb,src,targetIndex){
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src=src;
        mainImage.alt=thumb.dataset.alt||'';
        mainImage.setAttribute('data-media-id',thumb.dataset.mediaId||'');
        index=targetIndex;
        thumbs.forEach(function(item,itemIndex){
          var active=itemIndex===index;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-current',active?'true':'false');
        });
        if(counter)counter.textContent=String(index+1);
        thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
        preloadAround(index);
      }
      function showImage(nextIndex){
        if(!thumbs.length||!mainImage)return;
        var targetIndex=(nextIndex+thumbs.length)%thumbs.length;
        var thumb=thumbs[targetIndex];
        var src=imageSource(thumb);
        var request=++imageRequest;
        index=targetIndex;
        var loader=imageCache[src];
        if(loader&&loader.complete&&loader.naturalWidth){
          commitImage(thumb,src,targetIndex);
          return;
        }
        if(!loader){
          loader=new Image();
          loader.decoding='async';
          imageCache[src]=loader;
        }
        loader.fetchPriority='high';
        loader.onload=function(){if(request===imageRequest)commitImage(thumb,src,targetIndex)};
        loader.onerror=function(){if(request===imageRequest)commitImage(thumb,src,targetIndex)};
        if(!loader.src)loader.src=src;
      }
      preloadAround(index);
      thumbs.forEach(function(thumb,thumbIndex){thumb.addEventListener('click',function(){showImage(thumbIndex)})});
      if(prev)prev.addEventListener('click',function(){showImage(index-1)});
      if(next)next.addEventListener('click',function(){showImage(index+1)});
      var mediaCard=root.querySelector('.vpr__media-card');
      if(mediaCard&&thumbs.length>1){
        var galleryTouchStart=null;
        mediaCard.addEventListener('touchstart',function(event){
          if(event.touches.length!==1){galleryTouchStart=null;return}
          galleryTouchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
        },{passive:true});
        mediaCard.addEventListener('touchend',function(event){
          if(!galleryTouchStart||!event.changedTouches.length)return;
          var dx=event.changedTouches[0].clientX-galleryTouchStart.x;
          var dy=event.changedTouches[0].clientY-galleryTouchStart.y;
          galleryTouchStart=null;
          if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)*1.25)showImage(index+(dx<0?1:-1));
        },{passive:true});
        mediaCard.addEventListener('touchcancel',function(){galleryTouchStart=null},{passive:true});
      }
      function updateThumbNavigation(){
        if(!thumbScroller)return;
        if(thumbsUp)thumbsUp.disabled=thumbScroller.scrollTop<=1;
        if(thumbsDown)thumbsDown.disabled=thumbScroller.scrollTop+thumbScroller.clientHeight>=thumbScroller.scrollHeight-1;
      }
      function scrollThumbs(direction){
        if(!thumbScroller)return;
        thumbScroller.scrollBy({top:direction*Math.max(120,thumbScroller.clientHeight*.72),behavior:'smooth'});
      }
      if(thumbsUp)thumbsUp.addEventListener('click',function(){scrollThumbs(-1)});
      if(thumbsDown)thumbsDown.addEventListener('click',function(){scrollThumbs(1)});
      if(thumbScroller)thumbScroller.addEventListener('scroll',updateThumbNavigation,{passive:true});
      window.addEventListener('resize',updateThumbNavigation,{passive:true});
      updateThumbNavigation();

      var dimensionOpen=root.querySelector('[data-dimension-open]');
      var dimensionModal=root.querySelector('[data-dimension-modal]');
      var dimensionClose=root.querySelector('[data-dimension-close]');
      if(dimensionOpen&&dimensionModal){
        dimensionOpen.addEventListener('click',function(){dimensionModal.showModal()});
        if(dimensionClose)dimensionClose.addEventListener('click',function(){dimensionModal.close()});
        dimensionModal.addEventListener('click',function(event){if(event.target===dimensionModal)dimensionModal.close()});
        dimensionModal.addEventListener('close',function(){dimensionOpen.focus()});
      }

      var variantsNode=root.querySelector('[data-variants-json]');
      var variants=variantsNode?JSON.parse(variantsNode.textContent):[];
      var optionGroups=Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
      var variantInput=root.querySelector('[data-variant-id]');
      var price=root.querySelector('[data-price]');
      var compare=root.querySelector('[data-compare-price]');
      var status=root.querySelector('[data-status]');
      var addButton=root.querySelector('[data-add-button]');
      var addLabel=root.querySelector('[data-add-label]');
      var dimensionNodes=Array.prototype.slice.call(root.querySelectorAll('[data-selected-dimensions]'));
      var dimensionMap={};
      var dimensionMapNode=root.querySelector('[data-variant-dimensions-json]');
      try{dimensionMap=dimensionMapNode?JSON.parse(dimensionMapNode.textContent):{}}catch(error){dimensionMap={}}
      var currencySymbol=root.dataset.currencySymbol||'$';
      function money(cents){return currencySymbol+(Number(cents||0)/100).toFixed(2)}
      function selectedOptions(){return optionGroups.map(function(group){var active=group.querySelector('[data-option-value].is-active');return active?active.dataset.optionValue:''})}
      function updateVariant(){
        var selected=selectedOptions();
        var variant=variants.find(function(item){return selected.every(function(value,itemIndex){return String(item.options[itemIndex])===String(value)})});
        optionGroups.forEach(function(group){var selectedLabel=group.querySelector('[data-selected-option]');var active=group.querySelector('[data-option-value].is-active');if(selectedLabel&&active)selectedLabel.textContent=active.dataset.optionValue});
        if(!variant)return;
        if(variantInput)variantInput.value=variant.id;
        if(price)price.textContent=money(variant.price);
        if(compare){if(variant.compare_at_price&&Number(variant.compare_at_price)>Number(variant.price)){compare.textContent=money(variant.compare_at_price);compare.classList.remove('is-hidden')}else{compare.textContent='';compare.classList.add('is-hidden')}}
        if(status)status.innerHTML=variant.available?'<span class="vpr__status-dot"></span>'+root.dataset.inStockText:root.dataset.soldOutText;
        if(addButton)addButton.disabled=!variant.available;
        if(addLabel)addLabel.textContent=variant.available?root.dataset.addText:root.dataset.soldOutText;
        var nextDimensions=dimensionMap[variant.title]||'';
        if(nextDimensions)dimensionNodes.forEach(function(node){node.textContent=nextDimensions});
        if(variant.featured_media&&variant.featured_media.id){var mediaThumb=thumbs.find(function(item){return String(item.dataset.mediaId)===String(variant.featured_media.id)});if(mediaThumb)showImage(thumbs.indexOf(mediaThumb))}
        if(window.history&&window.history.replaceState){var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url.toString())}
      }
      optionGroups.forEach(function(group){group.querySelectorAll('[data-option-value]').forEach(function(button){button.addEventListener('click',function(){group.querySelectorAll('[data-option-value]').forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false')});button.classList.add('is-active');button.setAttribute('aria-pressed','true');updateVariant()})})});
      var quantity=root.querySelector('[data-qty-input]');
      var minus=root.querySelector('[data-qty-minus]');
      var plus=root.querySelector('[data-qty-plus]');
      if(minus&&quantity)minus.addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)-1)});
      if(plus&&quantity)plus.addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)+1)});
    }
    function initAll(){document.querySelectorAll('.vpr[data-section-id]').forEach(initSection)}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll)}else{initAll()}
    document.addEventListener('shopify:section:load',function(event){var root=event.target.querySelector('.vpr[data-section-id]');if(root)initSection(root)});
  })();

(function(){
function initPremiumAuto(scope){
scope.querySelectorAll('.vpr--cabinet-one [data-feature-slider],.vpr--cabinet-one .vpr__card--materials').forEach(function(root){
if(root.dataset.premiumAuto)return;
var feature=root.hasAttribute('data-feature-slider'),track=root.querySelector('.vk-features__track'),pages=feature?Array.from(track.children):Array.from(root.querySelectorAll('.vk-copy-page'));
if(pages.length<2)return;
root.dataset.premiumAuto='true';
var controls=document.createElement('div');controls.className='vk-auto-controls';
var toggle=document.createElement('button');toggle.type='button';toggle.className='vk-auto-toggle';
var reduced=window.matchMedia('(prefers-reduced-motion: reduce)'),paused=reduced.matches,hover=false,visible=false,last=Date.now(),interval=feature?6500:9000;
function setToggle(){toggle.textContent=paused?'Play slideshow':'Pause slideshow';toggle.setAttribute('aria-label',(paused?'Play ':'Pause ')+(feature?'main features':'materials')+' slideshow')}
function index(){return feature?Math.round(track.scrollLeft/(track.firstElementChild.getBoundingClientRect().width+16)):Math.max(0,pages.findIndex(function(p){return !p.hidden}))}
function go(n){if(feature)track.scrollTo({left:n*(track.firstElementChild.getBoundingClientRect().width+16),behavior:reduced.matches?'auto':'smooth'});else root.querySelectorAll('.vk-copy-dot')[n].click();last=Date.now()}
if(feature){var dots=document.createElement('div');dots.className='vk-auto-dots';pages.forEach(function(p,n){var b=document.createElement('button');b.type='button';b.className='vk-auto-dot';b.setAttribute('aria-label','Show feature '+(n+1));b.addEventListener('click',function(){go(n)});dots.appendChild(b)});controls.appendChild(dots);function sync(){Array.from(dots.children).forEach(function(b,n){b.setAttribute('aria-current',n===index()?'true':'false')})}track.addEventListener('scroll',sync,{passive:true});sync()}
toggle.addEventListener('click',function(){paused=!paused;last=Date.now();setToggle()});setToggle();controls.appendChild(toggle);
if(feature)root.appendChild(controls);else root.querySelector('.vpr__detail-body').appendChild(controls);
root.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')hover=true});
root.addEventListener('pointerleave',function(){hover=false;last=Date.now()});
root.addEventListener('pointerdown',function(){last=Date.now()},{passive:true});
root.addEventListener('keydown',function(){last=Date.now()});
root.addEventListener('click',function(e){if(e.isTrusted)last=Date.now()});
root.addEventListener('focusout',function(){last=Date.now()});
var observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;last=Date.now()},{threshold:.35});observer.observe(root);
var timer=setInterval(function(){if(!root.isConnected){clearInterval(timer);observer.disconnect();return}if(paused||hover||!visible||document.hidden||root.contains(document.activeElement)||(!feature&&!root.open)){last=Date.now();return}if(Date.now()-last>=interval)go((index()+1)%pages.length)},500);
reduced.addEventListener('change',function(){if(reduced.matches){paused=true;setToggle()}last=Date.now()});
});
}
function run(){initPremiumAuto(document)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
document.addEventListener('shopify:section:load',function(e){initPremiumAuto(e.target)});
})();


(function(){
  function initContentTabs(root){
    if(!root||root.dataset.contentTabsReady==='true')return;
    var tabsRoot=root.querySelector('[data-vpr-content-tabs]');
    var grid=root.querySelector('[data-vpr-content-grid]');
    var main=grid&&grid.querySelector('.vpr__content-main');
    var aside=grid&&grid.querySelector('.vpr__content-aside');
    if(!tabsRoot||!grid||!main||!aside)return;
    root.dataset.contentTabsReady='true';

    function classify(node){
      if(node.matches('.vpr__card--details'))return 'overview';
      if(node.matches('.vk-features'))return 'features';
      if(node.matches('.vpr__card--included,.vpr__card--specifications'))return 'specs';
      if(node.matches('.vpr__two-up')&&node.querySelector('.vpr__card--materials,.vpr__card--dimensions'))return 'materials';
      if(node.matches('.vpr__two-up')&&node.querySelector('.vpr__card--compatibility,.vpr__card--installation'))return 'fit';
      var text=(node.textContent||'').toLowerCase();
      if(text.indexOf('door hardware')>-1||text.indexOf('integrated lighting')>-1)return 'features';
      if(text.indexOf('make it your own')>-1)return 'overview';
      return 'overview';
    }

    Array.prototype.slice.call(main.children).forEach(function(node){node.dataset.vprGroup=classify(node)});
    aside.dataset.vprGroup='support';

    var buttons=Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-vpr-content-tab]'));
    var groups={overview:0,features:0,materials:0,specs:0,fit:0,support:aside.children.length?1:0};
    main.querySelectorAll('[data-vpr-group]').forEach(function(node){groups[node.dataset.vprGroup]=(groups[node.dataset.vprGroup]||0)+1});
    buttons.forEach(function(button){if(!groups[button.dataset.vprContentTab])button.hidden=true});

    function activate(name,focus){
      var available=buttons.find(function(button){return !button.hidden&&button.dataset.vprContentTab===name});
      if(!available)available=buttons.find(function(button){return !button.hidden});
      if(!available)return;
      name=available.dataset.vprContentTab;
      buttons.forEach(function(button){
        var active=button===available;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-selected',active?'true':'false');
        button.tabIndex=active?0:-1;
      });
      main.querySelectorAll('[data-vpr-group]').forEach(function(node){node.hidden=node.dataset.vprGroup!==name});
      grid.classList.toggle('is-support-active',name==='support');
      if(name==='support')aside.hidden=false;else aside.hidden=true;
      if(focus)available.focus({preventScroll:true});
    }

    buttons.forEach(function(button,index){
      button.addEventListener('click',function(){activate(button.dataset.vprContentTab,false)});
      button.addEventListener('keydown',function(event){
        if(event.key!=='ArrowRight'&&event.key!=='ArrowLeft'&&event.key!=='Home'&&event.key!=='End')return;
        event.preventDefault();
        var visible=buttons.filter(function(item){return !item.hidden});
        var current=visible.indexOf(button),next=current;
        if(event.key==='ArrowRight')next=(current+1)%visible.length;
        if(event.key==='ArrowLeft')next=(current-1+visible.length)%visible.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=visible.length-1;
        activate(visible[next].dataset.vprContentTab,true);
      });
    });
    activate('overview',false);
  }
  function initAllContentTabs(scope){
    if(scope.matches&&scope.matches('.vpr[data-section-id]'))initContentTabs(scope);
    if(scope.querySelectorAll)scope.querySelectorAll('.vpr[data-section-id]').forEach(initContentTabs);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAllContentTabs(document)});else initAllContentTabs(document);
  document.addEventListener('shopify:section:load',function(event){initAllContentTabs(event.target)});
})();


  } catch(e) { console.error(e); }
})();
})();
